import { useEffect, useState } from "react";
import { hasCookieChoice, isAcceptAll, isTrackingAllowed } from "../utils/cookieConsentUtils";

const readConsentState = () => ({
  choiceMade: hasCookieChoice(),
  acceptAll: isAcceptAll(),
  trackingAllowed: isTrackingAllowed(),
});

export const useCookieConsentState = () => {
  const [state, setState] = useState(readConsentState);

  useEffect(() => {
    const update = () => {
      const next = readConsentState();
      setState((prev) =>
        prev.choiceMade === next.choiceMade &&
        prev.acceptAll === next.acceptAll &&
        prev.trackingAllowed === next.trackingAllowed
          ? prev
          : next
      );
    };
    update();
    window.addEventListener("cookieConsentChanged", update);
    return () => window.removeEventListener("cookieConsentChanged", update);
  }, []);

  return state;
};

export const useAcceptAll = () => useCookieConsentState().acceptAll;

export const useTrackingAllowed = () => useCookieConsentState().trackingAllowed;

const useCookieChoiceMade = () => useCookieConsentState().choiceMade;

export default useCookieChoiceMade;
